import {createContext} from 'react';

const CloudMagicContext = createContext({});

export default CloudMagicContext;
